<button #button *ngIf="!secondLine" [disabled]="!!disabled" [class]="getCssClass()" mat-stroked-button [color]="color">
    <mat-icon *ngIf="icon" class="icon-{{icon}}">{{icon}}</mat-icon>
    <span class="firstLine">{{firstLine}}</span>
</button>

<button #button *ngIf="secondLine" [disabled]="!!disabled" [class]="getCssClass()" mat-stroked-button [color]="color">
    <mat-icon *ngIf="icon" class="icon-{{icon}}">{{icon}}</mat-icon>
    <span class="firstLine">{{firstLine}}</span>
    <span class="secondLine">{{secondLine}}</span>
</button>